import { Controller, Menu } from '@tencent/workbench';
import { ReplaceFontFeature } from './replace-font-feature';
import { INSERT_TEXT_MENU_CONFIGS, config } from './config';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';

@Controller({
    menuItems: INSERT_TEXT_MENU_CONFIGS,
})
export class ReplaceFontController {
    public constructor(private readonly feature: ReplaceFontFeature) {
    }

    @Menu(config.id, 'onClick')
    public onClick() {
        this.feature.getAppService()
            .editableServiceLayer?.quickToolDialogManager.promise().then((quickToolDialogManager) => {
                quickToolDialogManager.showDialog(ActionType.REPLACE_FONT);
            });
    }
}
